import { FC } from 'react';
import { clsx } from 'clsx';

import { adjustPathname } from '@monoimin/utils/helpers';

import { Typography, Avatar, SharedLink, Icons } from '@monoimin/atoms';
import { CardProps } from '@monoimin/sb-types';

const CardTitleAndDescription: FC<
  Pick<
    CardProps,
    | 'title'
    | 'variant'
    | 'classNames'
    | 'description'
    | 'author'
    | 'overtitle'
    | 'author'
    | 'prefetch'
    | 'url'
    | 'target'
    | 'link'
  >
> = ({
  title,
  classNames,
  description,
  overtitle,
  author,
  prefetch,
  url,
  target,
  link,
}) => {
  return (
    <div className='flex flex-col'>
      {!!overtitle && (
        <Typography
          className={clsx(
            'caption font-bold text-blue-500 mb-2',
            classNames?.overtitle
          )}
        >
          {overtitle}
        </Typography>
      )}
      <SharedLink
        underline='off'
        href={adjustPathname(link?.url ?? url)}
        prefetch={prefetch}
        fullSizeOverlay
        target={target || '_self'}
      >
        {!!title && (
          <Typography
            className={clsx(
              'card-title',
              'font-bold line-clamp-3',
              classNames?.title
            )}
          >
            {title}
          </Typography>
        )}
      </SharedLink>
      {description && (
        <Typography className={clsx('body mt-3', classNames?.description)}>
          {description}
        </Typography>
      )}
      {author && (
        <div className='flex gap-2 mt-2 items-center'>
          <Avatar
            src={author.image}
            alt={author.name}
            size={24}
            className='w-6 h-6'
          />
          <Typography className='caption'>{author.name}</Typography>
        </div>
      )}
      {link && (
        <SharedLink
          className='text-blue-400 body flex gap-2 items-center mt-5 md:mt-9'
          href={link.url}
        >
          <span>{link.title}</span>
          <Icons
            icon='arrowRight'
            className='w-6 h-6 bg-blue-400'
            isInteractive
          />
        </SharedLink>
      )}
    </div>
  );
};

export default CardTitleAndDescription;
